import '../social_content_context_view.js.coffee'
Monitoring.Views ||= {}

class Monitoring.Views.InstagramMessageContextView extends Monitoring.Views.SocialContentContextView

  newSearch: =>
    contextClasses = []
    contextClasses.push Monitoring.Views.InstagramContentParentStoryView
    contextClasses.push Monitoring.Views.InstagramMessageCurrentMessageView

    _.each(contextClasses, (contextClass) =>
      new contextClass({el: @$el, socialContent: @socialContent}).fetch()
    )
    @show()
